/**
 * Store links for the GoTu mobile app.
 *
 * `com.tempmeeapp` is the production `applicationId` declared in
 * mobile-app/android/app/build.gradle.
 */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/tempmee/id1437086894';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.tempmeeapp';

// Match Android rather than Apple: every Android browser UA (Chrome, Firefox,
// Samsung Internet, WebView) carries the literal `Android`, whereas iOS spreads
// across iPhone/iPad/iPod and iPadOS 13+ Safari reports itself as `Macintosh`.
// Testing the reliable half and defaulting to the App Store preserves today's
// behaviour for every UA we don't recognise, so this can only ever fix Android
// users — it cannot break the iOS users who already work.
export const getMobileStoreUrl = (userAgent: string = navigator.userAgent): string =>
  /android/i.test(userAgent) ? PLAY_STORE_URL : APP_STORE_URL;

// The portal has no phone/tablet layout; those users get the download screen
// instead (GOTU-19799). Matched by device, never by window width, so a narrow
// desktop window is still the portal. iPadOS 13+ Safari sends a Macintosh UA,
// so an iPad is a Mac UA with a touchscreen (navigator.maxTouchPoints is 0 on
// desktop Macs, 5 on iPads). The touchscreen test stays scoped to Macintosh
// because Windows touchscreen laptops report touch points too.
export const isPhoneOrTablet = (
  userAgent: string = navigator.userAgent,
  maxTouchPoints: number = navigator.maxTouchPoints ?? 0,
): boolean =>
  /android|iphone|ipad|ipod/i.test(userAgent) ||
  (/macintosh/i.test(userAgent) && maxTouchPoints > 1);
